import React from 'react'
import { Container } from 'react-bootstrap';
import Best from '../components/Best';
import Luxury from '../components/Luxury'
import StickyBanner from "../components/StickyBanner"
import banner11 from "../assets/banner/Banner2.jpeg"
import Work from "../components/Work"
// import Testimonials from '../components/Testimonials'
import { motion } from "framer-motion";


import "./About.css"

const About = () => {
  return (
    <>
      {/* <PageTopBanner
        title="About Us"
        currentPage="About Us"
        backgroundImage={require("../assets/banner/Banner2.jpeg")}
      /> */}
     <StickyBanner
        image={banner11}
        title="About Us"
        currentPage="About Us"
      />
  
 
{/* section 1 */}
<section className="aboutdemo-section">
  <Container className="about-section1-container">
    <div className="about-section1-text ">
      <div className='heading-center-underline'>
      <h2 className='page-heading'>About Our Company</h2>
</div>
      <p className='page-description'>
   WE ARE MEGA GROUP. WE ARE BUILDERS WITH ONE GOAL AND ONE IDEAL: 
   "BETTER LIVING". WE HAVE BEEN WORKING TIRELESSLY TO BRING THE FUTURE ONE STEP 
   CLOSER TO THE PRESENT PROVIDING THE UTMOST QUALITY OF LIVING, BETTERMENT OF NEIGHBORHOOD AND MAKING EVERY SINGLE DWELLING BETTER THAN THE PREVIOUS ONE. THESE ARE SOME STRONG IDEALS ON WHICH THE FOUNDATION OF OUR COMPANY STANDS.
      </p>
    </div>

  <div className="about-section1-stats">
  {[
    { label: "Quality", value: 100 },
    { label: "Living Experience", value: 95 },
    { label: "Greenery", value: 85 },
    { label: "Support", value: 100 },
  ].map((item, index) => (
    <div className="about-stat-item" key={index}>
      {/* Label ABOVE line */}
      <div className="about-stat-top">
        <span className="about-stat-label">{item.label}</span>
        <span className="about-stat-value">{item.value}%</span>
      </div>

      {/* Line with outline */}
      <div className="about-stat-line-bg">
        <motion.div
          className="about-stat-line-fill"
          initial={{ width: 0 }}
          whileInView={{ width: `${item.value}%` }}
          transition={{ duration: 1.2, ease: "easeOut" }}
          viewport={{ once: true }}
        />
      </div>
    </div>
  ))}
</div>
  </Container>
</section>

{/* section 1 end */}
<Best/>
      <Luxury />
{/*  */}
      <motion.div
        initial={{ opacity: 0, y: 80 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        {/* <Testimonials /> */}
      </motion.div>
   <motion.div
        initial={{ opacity: 0, y: 80 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
<div className='about-seprate-section'>
<Container className='about-seprate-div'>
   <div className=''>
          <h3 className="page-heading text-center">QUALITY | TRUST | LEGACY</h3>
        </div>
        <div>

        </div>
  <p className='page-description about-seprate-para '>WE HAVE BEEN DELIVERING EVERY SINGLE PROMISE SINCE DAY ONE AND AIM TO DO SO IN THE FUTURE BECAUSE ONLY THING BIGGER AND MORE COMFORTABLE THAN A HOUSE IS A WARM HEART WITH A FULFILLED WISH AND PROMISE, THE EXACT THING WE WISH TO LOOK IN THE EYE OF OUR CUSTOMER.</p>
</Container>
</div>
</motion.div>

 <motion.div
        initial={{ opacity: 0, y: 80 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
         <Work />
      </motion.div>



    </>
  )
}

export default About
